export const DiamondIcon = ({ className = "w-6 h-6" }: { className?: string }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16.0002 3L20.9992 10H11.0004L16.0002 3Z" fill="currentColor" />
      <path d="M10.9992 10L6.00017 3L1.00037 10H10.9992Z" fill="currentColor" />
      <path d="M30.9992 10L26.0002 3L21.0004 10H30.9992Z" fill="currentColor" />
      <path d="M10.9999 10.0002L15.9999 31.0002L20.9999 10.0002H10.9999Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 31L1 10H11L16 31Z" fill="currentColor" />
      <path d="M16 31L20.9998 10H30.9998L16 31Z" fill="currentColor" />
      <path d="M10.9994 10L6.00037 3H15.9992L10.9994 10Z" fill="currentColor" fillOpacity="0.2" />
      <path d="M20.9993 9.99988L16.0004 3H25.9992L20.9993 9.99988L16 30.9999L10.9994 10L20.9993 9.99988Z" fill="currentColor" fillOpacity="0.2" />
      <path d="M6 3L1 10M6 3H26M6 3L11 10M1 10L16 31M1 10H31M16 31L31 10M16 31L21 10M16 31L11 10M31 10L26 3M26 3L21 10M21 10L16 3L11 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}; 